export default __webpack_public_path__ + "static/media/srisailamVisitFifteen.7943c2ac.jpg";